__webpack_require__.b = document.baseURI || self.location.href;

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
var installedChunks = {
	29753: 0,
	3201: 0,
	6315: 0,
	9389: 0,
	16902: 0,
	22225: 0,
	28773: 0,
	28970: 0,
	31146: 0,
	37415: 0,
	38074: 0,
	45338: 0,
	48727: 0,
	50531: 0,
	57293: 0,
	57431: 0,
	58281: 0,
	60229: 0,
	64492: 0,
	65404: 0,
	72560: 0,
	73369: 0,
	73560: 0,
	73575: 0,
	76413: 0,
	76512: 0,
	76949: 0,
	83846: 0,
	85243: 0,
	90920: 0,
	91422: 0,
	91472: 0,
	95721: 0,
	78046: 0,
	40311: 0,
	55485: 0,
	56847: 0,
	75134: 0,
	89316: 0,
	8073: 0,
	8: 0,
	19667: 0
};

__webpack_require__.f.j = (chunkId, promises) => {
		// JSONP chunk loading for javascript
		var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
		if(installedChunkData !== 0) { // 0 means "already installed".

			// a Promise means "currently loading".
			if(installedChunkData) {
				promises.push(installedChunkData[2]);
			} else {
				if(!/^(1(4(81[34]|148)|(022|279|296|826)4|6[79]02|3398|7|8951|9667)|2(4([37]56|291)|8(97[04]|633|773)|090|1628|1859|2225|2633|3048|3264|5311|6660|9442|9753)|3(1146|201|7415|7904|8074|8557)|4(0311|048|4483|494|5338|6846|6955|8221|8727)|5(7(293|415|431|500)|9(195|397|450)|(053|4|828)1|(075|138|684)7|5378|5485)|6(0229|1526|2482|315|4008|4492|5404|5845)|7(2(560|75|966)|3(369|560|575|990)|46(50|67)|6(413|512|949)|1085|1699|5134|5733|8046|9222|9326)|8(5(243|32|733)||073|3846|7861|8179|9316|971)|9(1(4(22|72|91)|570)|7(355|79|927)|0920|3034|389|4966|5294|5721|8373|9300|9996))$/.test(chunkId)) {
					// setup Promise in chunk cache
					var promise = new Promise((resolve, reject) => (installedChunkData = installedChunks[chunkId] = [resolve, reject]));
					promises.push(installedChunkData[2] = promise);

					// start chunk loading
					var url = __webpack_require__.p + __webpack_require__.u(chunkId);
					// create error before stack unwound to get useful stacktrace later
					var error = new Error();
					var loadingEnded = (event) => {
						if(__webpack_require__.o(installedChunks, chunkId)) {
							installedChunkData = installedChunks[chunkId];
							if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
							if(installedChunkData) {
								var errorType = event && (event.type === 'load' ? 'missing' : event.type);
								var realSrc = event && event.target && event.target.src;
								error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
								error.name = 'ChunkLoadError';
								error.type = errorType;
								error.request = realSrc;
								installedChunkData[1](error);
							}
						}
					};
					__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
				} else installedChunks[chunkId] = 0;
			}
		}
};

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);

// install a JSONP callback for chunk loading
var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
	var [chunkIds, moreModules, runtime] = data;
	// add "moreModules" to the modules object,
	// then flag all "chunkIds" as loaded and fire callback
	var moduleId, chunkId, i = 0;
	if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
		for(moduleId in moreModules) {
			if(__webpack_require__.o(moreModules, moduleId)) {
				__webpack_require__.m[moduleId] = moreModules[moduleId];
			}
		}
		if(runtime) var result = runtime(__webpack_require__);
	}
	if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
	for(;i < chunkIds.length; i++) {
		chunkId = chunkIds[i];
		if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
			installedChunks[chunkId][0]();
		}
		installedChunks[chunkId] = 0;
	}
	return __webpack_require__.O(result);
}

var chunkLoadingGlobal = globalThis["webpackChunk_github_ui_github_ui"] = globalThis["webpackChunk_github_ui_github_ui"] || [];
chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));